import Axios from './Axios';

export const getInvitations = _ => Axios.get('/invitations?[scopes]=pending');
export const acceptInvitation = id => Axios.post(`/invitations/${id}/accept`);
